<div class="container">

    <div fxLayout="column">

        <div fxLayout="row" fxFlex="100" fxLayoutAlign="center center">


            <div fxLayoutAlign="center center" *ngIf="name.length>0">
                <calsoft-translator [translateValue]="name" [type]="'productsdetails'"></calsoft-translator>

                <div style="padding-left: 10px;">
                    <span style="font-size: 16px;" fxLayoutAlign="center center" [innerHTML]="description"></span>
                </div>

                
             
            </div>
        </div>


        <div *ngIf="data.enableDownloadPdf==1">
            <div *ngIf="PdfDownload==1" fxLayout="row" class="padding-tb" fxLayoutAlign="end center">
                <div *ngIf="fileName!=undefined">
                    <span class="space">
                        download
                    </span>
                    <button (click)="downloadPdf()" color="warn" mat-icon-button type="button" class="center-button btn-video btn-iframe">
                        <mat-icon>download</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        

    </div>
    <div fxLayout="row" class="padding-tb1" fxLayoutAlign="center center">
        <div style="width: 100%" *ngIf="fileNameExist" fxLayout="row" class="topclass"
            fxLayoutAlign="space-between center">
            <calsoft-pdf-viewer style="width: 100%" [fileName]="fileName"></calsoft-pdf-viewer>
        </div>
    </div>

</div>